module.exports = __webpack_public_path__ + "static/media/BitvoLogo.b07832f8.png";